import axios from 'axios'
import Vue from 'vue'
export default {
  // 获取用户信息
  getSysUserInfo: async function (requestUrl) {
    axios({
      headers: {
        'Content-Type': 'application/json;charset=UTF-8;',
        Authorization: localStorage.getItem('Authorization')
      },
      method: 'GET',
      url: requestUrl,
      params: {}
    }).then((res) => {
      if (res.data.sysUserInfo) {
        const additionalData = res.data.sysUserInfo
        localStorage.setItem('saveUserInfo', JSON.stringify(additionalData))
      }
    }).catch((err) => {
      Vue.$showLoading.hide()
      console.log(err)
    })
  },
  dict_group () {
    const group = [
      {
        dictCode: 1,
        dictLabel: '小初组（1-2年级）',
        dictValue: 0
      },
      {
        dictCode: 2,
        dictLabel: '小中组（3-4年级）',
        dictValue: 1
      },
      {
        dictCode: 3,
        dictLabel: '小高组（5-6年级）',
        dictValue: 2
      },
      {
        dictCode: 4,
        dictLabel: '初中组（7-9年级）',
        dictValue: 3
      },
      {
        dictCode: 5,
        dictLabel: '高中组（10-12年级）',
        dictValue: 4
      }
    ]
    return group
  }
}
